import React from "react";
import { Mail, Code } from "lucide-react";
import { GithubIcon, LinkedinIcon, TwitterIcon } from "../common/icons";
import INFO from "../../data/user";
import "./styles/socials.css";

const Socials = () => {
	return (
		<div className="socials">
			<div className="social">
				<a href={INFO.socials.github} target="_blank" rel="noreferrer">
					<GithubIcon size={18} />
					<span>Follow on GitHub</span>
				</a>
			</div>

			<div className="social">
				<a href={INFO.socials.linkedin} target="_blank" rel="noreferrer">
					<LinkedinIcon size={18} />
					<span>Connect on LinkedIn</span>
				</a>
			</div>

			<div className="social">
				<a href={INFO.socials.leetcode} target="_blank" rel="noreferrer">
					<Code size={18} />
					<span>LeetCode Profile</span>
				</a>
			</div>

			<div className="social">
				<a href={INFO.socials.twitter} target="_blank" rel="noreferrer">
					<TwitterIcon size={18} />
					<span>Follow on Twitter</span>
				</a>
			</div>

			<div className="email">
				<a href={`mailto:${INFO.main.email}`}>
					<Mail size={18} color="#06b6d4" />
					<span>{INFO.main.email}</span>
				</a>
			</div>
		</div>
	);
};

export default Socials;
